import React from "react";
import { ResponsiveRadar } from "@nivo/radar";

const theme = {
  axis: {
    ticks: {
      text: {
        fill: "#fff",
        fontFamily: '"Exo", sans-serif',
      },
    },
    legend: {
      text: {
        fill: "#fff",
        fontFamily: '"Exo", sans-serif',
      },
    },
  },
  grid: {
    line: { stroke: "#333" },
  },
  labels: {
    text: {
      fontWeight: "bold", // Make arc labels bold
      fontSize: ".8rem",
      fontFamily: '"Exo", sans-serif', // Set font family for arc labels
    },
  },
  tooltip: {
    container: {
      background: "#333",
      color: "#fff", // Set tooltip text color to black
      fontFamily: '"Exo", sans-serif',
    },
  },
};

const NivoRadar = ({ data, colors }) => {
  const transformedData =
    data?.slice(1)?.map(([id, value]) => ({ label: id, value })) || [];

  if (!transformedData.length) {
    return null;
  }
  return (
    <div
      className="pie-chart-container"
      style={{ width: "100%", height: 280, paddingTop: 10 }}
    >
      <ResponsiveRadar
        data={transformedData}
        keys={["value"]}
        indexBy="label"
        valueFormat=">-.1f"
        borderWidth={3}
        margin={{ top: 40, right: 40, bottom: 80, left: 40 }}
        borderColor={{ from: "color" }}
        gridLabelOffset={12}
        dotSize={10}
        dotColor={colors}
        dotBorderWidth={2}
        colors={colors}
        blendMode="multiply"
        motionConfig="wobbly"
        theme={theme}
        fillOpacity={1}
      />
    </div>
  );
};

export default NivoRadar;
